import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import persistanceConfig from './persistance.config'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  'key': persistanceConfig.storageKey
})

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
  plugins: [vuexLocal.plugin]
})
